import { commitMutation } from "react-relay";
import graphql from "babel-plugin-relay/macro";

const mutation = graphql`
  mutation removeNotificationMutation($input: notificationDeleteInput!) {
    notificationDelete(input: $input) {
      clientMutationId
    }
  }
`;

function removeUpdater(store, notification_id, context_id) {
  const rootProxy = store.get(context_id);
  rootProxy.setLinkedRecords(
    rootProxy
      .getLinkedRecords("notifications")
      .filter(n => n.getValue("id") !== notification_id),
    "notifications"
  );
}

function commit(environment, input, context_id) {
  return commitMutation(environment, {
    mutation,
    variables: { input },
    optimisticUpdater: store => removeUpdater(store, input.id, context_id),
    updater: store => removeUpdater(store, input.id, context_id),
    onCompleted: response => response,
    onError: err => err
  });
}

export default commit;
